export var ArbitrumRinkeby = {
  chainId: 421611,
  chainName: 'ArbitrumRinkeby',
  isTestChain: true,
  isLocalChain: false,
  multicallAddress: '0xd27BEFd29F8Da4E187fDAEf663aEDF7742f9F47F',
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://testnet.arbiscan.io/address/".concat(address);
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://testnet.arbiscan.io/tx/".concat(transactionHash);
  }
};
export var Arbitrum = {
  chainId: 42161,
  chainName: 'Arbitrum',
  isTestChain: false,
  isLocalChain: false,
  multicallAddress: '0x8a0bd1773139C6609e861B9ab68082587a3cD581',
  multicall2Address: '0x80c7dd17b01855a6d2347444a0fcc36136a314de',
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://arbiscan.io/address/".concat(address);
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://arbiscan.io/tx/".concat(transactionHash);
  }
};
export default {
  ArbitrumRinkeby: ArbitrumRinkeby,
  Arbitrum: Arbitrum
};